import { render, staticRenderFns } from "./getWork.vue?vue&type=template&id=c831a2ce&scoped=true&"
import script from "./getWork.vue?vue&type=script&lang=js&"
export * from "./getWork.vue?vue&type=script&lang=js&"
import style0 from "./getWork.vue?vue&type=style&index=0&id=c831a2ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c831a2ce",
  null
  
)

export default component.exports